import React, { useState, useEffect } from 'react'
import { Parallax } from 'react-scroll-parallax'
import VisibilitySensor from 'react-visibility-sensor'
import scrollToElement from 'scroll-to-element'
import { isTablet, isMobile, isMobileOnly } from 'react-device-detect'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ScrollDown from './../svg/down-arrow.svg';
import '../css/LandingHero.scss'

const LandingHero = ({ headline, body, industries }) => {
  const [heroVisible, setHeroVisible] = useState(false)
  const [heroIndex, setHeroIndex] = useState(1)

  useEffect(() => {
    let heroInterval
    heroInterval = setInterval(iterateHeroImg, 4000)

    return () => {
      clearInterval(heroInterval)
    }
  }, [heroIndex])

  const iterateHeroImg = () => {
    let slides = document.getElementsByClassName('heroImage')
    let heroImage = document.querySelector('.heroImage.active')

    if ((heroIndex + 1) <= slides.length - 1) {
      setHeroIndex(heroIndex + 1)
    } else {
      setHeroIndex(0)
    }
    if (heroImage) {
      heroImage.classList.remove('active')
      slides[heroIndex].classList.add('active')
    }
  }

  const heroVisiblityChange = isVisible => {
    if (isVisible) {
      setHeroVisible(true)
    }
  }

  const scrollToFirstTime = e => {
    scrollToElement(`.industry_matrix`, {
      offset: 5, // this is temp
      ease: 'outExpo',
      duration: 750
    })
  }

  return (
    <VisibilitySensor onChange={heroVisiblityChange} partialVisibility>
      <div className={`page-hero ${heroVisible ? 'isVisible' : ''}`}>
        <div className='hero-content'>
          <Container>
            <Row>
              <Col sm={12} md={12} lg={5}>
                <div className='hero-content__main'>
                  <h1 className='hero-header homepage-headline fade-up'>{headline}</h1>
                  <Parallax
                    disabled={true}
                    className='hero-text fade-up'
                    y={isTablet ? [-0, -20] : [-5, 5]}
                    styleInner={isMobileOnly ? { marginTop: '0' } : null}
                  >
                    <p className='home-intro'>{body}</p>
                    <div className='scroll-button' onClick={scrollToFirstTime}>
                      <img src={ScrollDown} alt={'Scroll down'}/>
                    </div>
                  </Parallax>
                </div>
              </Col>
            </Row>
          </Container>
          <Parallax
            className='hero-image-container fade-up'
            y={isMobile ? isMobileOnly ? [-25, 20] : [-30, 30] : [10, -20]}
            disabled={isMobileOnly}
          >
            <div className={`hero-image`}>
              <div className={`image-container ${isMobile ? 'square' : 'sixteen'}`} >
                {
                  Object.keys(industries).map((industryKey, index, arr) =>
                    <img
                      src={`./img/industries/${industries[industryKey].image}`}
                      key={industryKey}
                      alt={headline}
                      index={index}
                      className={`heroImage ${industryKey} ${index === 0 ? 'active' : ''}`}
                    />
                  )
                }
              </div>
            </div>
          </Parallax>
        </div>
      </div>
    </VisibilitySensor>
  )
}

export default LandingHero
